import { useSetUserProgressVisibilityMutation } from 'academy-common-lib/__generated__/chirp/com/hubspot/learning/center/user/progress/rpc/UserProgressVisibilityChirpService.hooks';
import { getQueryFieldName } from 'academy-common-lib/utils/DataFetchingClientCache.new';
import { GET_PROGRESS_ITEMS_FOR_MY_LEARNING_PAGE_QUERY } from 'academy-common-lib/__generated__/chirp/com/hubspot/mylearning/bff/rpc/MyLearningBFFChirpService.dfc.new';
export const MY_LEARNING_QUERY_FIELD_NAME = getQueryFieldName(GET_PROGRESS_ITEMS_FOR_MY_LEARNING_PAGE_QUERY);
export const useUpdateUserProgressVisibility = variables => {
  return useSetUserProgressVisibilityMutation({
    variables,
    update: (cache, result) => {
      var _result$data;
      if ((_result$data = result.data) !== null && _result$data !== void 0 && _result$data.result) {
        cache.evict({
          fieldName: MY_LEARNING_QUERY_FIELD_NAME
        });
      }
    }
  });
};